import React, { ReactNode, createContext, useContext } from "react";

import { ExtendedWorkspace, MeetingModelJson } from "@performyard/service-contracts";

type MeetingContextType = {
	meeting: MeetingModelJson;
	userId: string;
	isExpanded: boolean;
	toggleAccordion: () => void;
	setEditingMeeting: (meeting: MeetingModelJson) => void;
	setUserAssignment: (userAssignment: {
		actionItemId: string;
		meetingId: string;
		currentAssigneeId?: string;
		dueDate?: Date | null;
		name?: string;
	}) => void;
	participantId?: string;
	participantName?: string;
	workspace?: ExtendedWorkspace;
	isInteractionDisabled?: boolean;
	isAdminView?: boolean;
};

const MeetingContext = createContext<MeetingContextType | undefined>(undefined);

export const MeetingProvider = ({ children, value }: { children: ReactNode; value: MeetingContextType }) => {
	return <MeetingContext.Provider value={value}>{children}</MeetingContext.Provider>;
};

export const useMeetingContext = (): MeetingContextType => {
	const context = useContext(MeetingContext);
	if (context === undefined) {
		throw new Error("useMeetingContext must be used within a MeetingProvider");
	}
	return context;
};
